import React from 'react';
import { Drawer } from 'baseui/drawer';

export type BaseDrawerProps = React.ComponentProps<typeof Drawer>;

export const BaseDrawer: React.FC<BaseDrawerProps> = (props) => {
  return <Drawer {...props} />;
};

export default BaseDrawer;


